export default {
  getIframeWebAppTabs(state) {
    console.log(state, 'state')
    return state.tabs.filter((item) => (item.path || '').startsWith('http'))
  },
}
